import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";

import { States } from "@qqcw/qqsystem-util";
import { licenseMask, vinMask } from "src/app/shared/utilities/ngx-mask-custom";

import { rationalizeLicense, rationalizeVIN } from "src/lib/util";
import { licenseIsValid, vinIsValid } from "src/lib/validators";

import { AccountCheckLast4PlateRequest } from "src/app/core/services/myqq/myqq.models";
import { Subscription } from "rxjs";

type VinOrPlate = "vin" | "plate";
@Component({
  selector: "myqq-last4lookup",
  templateUrl: "./last4lookup.component.html",
  styleUrls: ["./last4lookup.component.scss"],
})
export class Last4lookupComponent implements OnInit, OnDestroy {
  @Output()
  submitLast4Lookup = new EventEmitter<AccountCheckLast4PlateRequest>();
  @Output()
  skip = new EventEmitter();

  readonly licenseMask = licenseMask;
  readonly vinMask = vinMask;
  readonly states = States;
  readonly lookupBy = { plate: "License Plate", vin: "VIN" };
  subs: Subscription[] = [];
  isVIN = false;

  form: FormGroup<{
    type: FormControl<VinOrPlate>;
    state: FormControl<string>;
    license: FormControl<string>;
    vin: FormControl<string>;
    last4: FormControl<string>;
  }>;
  validators = {
    state: [Validators.required],
    license: [Validators.required, licenseIsValid.bind(this)],
    vin: [Validators.required, vinIsValid.bind(this)],
  };
  constructor(private fb: FormBuilder, readonly cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.handleSetUpForm();
  }

  ngOnDestroy(): void {
    this.subs.forEach((s) => s.unsubscribe());
  }

  handleSetUpForm() {
    this.form = this.fb.group({
      type: ["plate" as VinOrPlate, [Validators.required]],
      state: [""],
      license: [""],
      vin: [""],
      last4: ["", [Validators.required, Validators.pattern(/^\d{4}$/)]],
    });
    const lookupByControl = this.form.get("type");

    // Set validators appropriately
    this.subs.push(
      lookupByControl.valueChanges.subscribe((option) => {
        this.isVIN = option === "vin";
        const stateControl = this.form.get("state");
        stateControl.setValidators(!this.isVIN ? this.validators.state : null);
        stateControl.updateValueAndValidity();

        Object.keys(this.lookupBy).forEach((key) => {
          key = key === "plate" ? "license" : "vin"; // fudge for inconsistent naming
          const formControl = this.form.get(key);
          formControl.setValidators(
            option === key ? this.validators[key] : null
          );
          formControl.updateValueAndValidity();
        });

        this.cdr.detectChanges();
        this.form.updateValueAndValidity();
      })
    );
  }

  submit() {
    if (this.form.valid) {
      const vehicle =
        this.form.get("type").value === "plate"
          ? {
              type: "plate" as "plate",
              state: this.form.value.state,
              license: rationalizeLicense(this.form.value.license),
              last4: this.form.value.last4,
            }
          : {
              type: "vin" as "vin",
              vin: rationalizeVIN(this.form.value.vin),
              last4: this.form.value.last4,
            };

      this.submitLast4Lookup.emit(vehicle);
    }
  }

  skipLookup() {
    this.skip.emit();
  }
}
